import { render, staticRenderFns } from "./BackofficeAgendamento.vue?vue&type=template&id=1b87974a"
import script from "./BackofficeAgendamento.vue?vue&type=script&lang=ts"
export * from "./BackofficeAgendamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports